import React from "react"
import autobind from "class-autobind"
import { ISchedulePatternTemplate, ISimpleTime, IScheduleShift } from "../../../models"
import { Dialog, FlatButton, SelectField, MenuItem, Toggle } from "material-ui"
import strings from "../../../localization/strings"
import AccountStore from "../../../stores/AccountStore"
import SimpleTimeEditor from "../../../components/common/SimpleTimeEditor"
import * as scheduleHelper from "../../../helpers/scheduleHelper"
import * as hierarchyHelper from "../../../helpers/hierarchyHelper"
import * as userHelper from "../../../helpers/userHelper"
import * as utils from "../../../helpers/utils"
interface IProps {
  patternTemplate: ISchedulePatternTemplate
  handleUpdate(patternTemplate: ISchedulePatternTemplate): void
  handleClose(): void
}
interface IState {
  shiftTemplate: IScheduleShift
  errorShiftTemplate: string
  startTime: ISimpleTime
  endTime: ISimpleTime
  errorOverlap: string
  overrideHierarchy: boolean
}

export default class AddShiftTemplateInPatternTemplate extends React.Component<IProps, IState> {
  constructor(props) {
    super(props)
    this.state = {
      shiftTemplate: null,
      errorShiftTemplate: "",
      startTime: null,
      endTime: null,
      errorOverlap: "",
      overrideHierarchy: false,
    }
    autobind(this)
  }

  checkValidate() {
    let isValidate = true
    if (!this.state.shiftTemplate) {
      this.setState({ errorShiftTemplate: strings.This_field_is_required })
      isValidate = false
    }
    else {
      this.setState({ errorShiftTemplate: "" })
    }
    const newShiftTemplate = Object.assign({}, this.state.shiftTemplate)
    newShiftTemplate.StartTime = this.state.startTime
    newShiftTemplate.EndTime = this.state.endTime
    if (scheduleHelper.checkOverlapShifts(newShiftTemplate, this.props.patternTemplate.ShiftTemplates)) {
      this.setState({ errorOverlap: "" })
    }
    else {
      this.setState({ errorOverlap: strings.Shift_template_time_is_overlapped })
      isValidate = false
    }
    return isValidate
  }

  handleSave() {
    if (!this.checkValidate()) return
    const newShiftTemplate = Object.assign({}, this.state.shiftTemplate)
    newShiftTemplate.StartTime = this.state.startTime
    newShiftTemplate.EndTime = this.state.endTime
    const patternTemplate = Object.assign({}, this.props.patternTemplate)
    patternTemplate.ShiftTemplates.push(newShiftTemplate)
    this.props.handleUpdate(this.state.overrideHierarchy ?
      scheduleHelper.overridePatternTemplateHierarchy(patternTemplate, this.props.patternTemplate.HierarchyId, null, null) :
      patternTemplate
    )
  }

  render() {
    return (
      <Dialog
        open={true}
        title={strings.Add_Shift_Template}
        titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
        actions={[
          <FlatButton
            label={strings.CANCEL}
            secondary={true}
            onClick={this.props.handleClose}
          />,
          <FlatButton
            label={strings.SAVE}
            primary={true}
            onClick={this.handleSave}
          />
        ]}
      >
        <hr />
        <div style={{ paddingRight: 20, paddingLeft: 20 }}>
          <Toggle
            label={strings.Override_hierarchy}
            toggled={this.state.overrideHierarchy}
            style={{ width: 225, marginTop: 25 }}
            onToggle={(e, value) => this.setState({ overrideHierarchy: value, shiftTemplate: null })}
          />
          <SelectField
            floatingLabelText={strings.Shift_Template}
            style={{ width: 250 }}
            value={this.state.shiftTemplate}
            onChange={(e, key, shiftTemplate: IScheduleShift) => this.setState({ shiftTemplate, startTime: shiftTemplate.StartTime, endTime: shiftTemplate.EndTime }, () =>
              this.checkValidate()
            )}
            errorText={this.state.errorShiftTemplate}
            errorStyle={{ position: "absolute", bottom: -10 }}
          >
            {utils.sortAlphabetical(AccountStore.getCurrentAccount().ScheduleData.ShiftTemplates, "Name").filter((item) =>
              !item.Deleted &&
              (this.state.overrideHierarchy ?
                userHelper.getSupervisorAccessHierarchyIds().includes(item.HierarchyId) :
                hierarchyHelper.getHierarchyIdsForShowAllChildHierarchyData(true, this.props.patternTemplate.HierarchyId).includes(item.HierarchyId)
              ) &&
              !this.props.patternTemplate.ShiftTemplates.find((existItem) => existItem.Id === item.Id))
              .map((item, index) =>
                <MenuItem value={item} primaryText={item.Name} key={index} />
              )}
          </SelectField>
          <div style={{ display: "flex", height: 75 }}>
            {this.state.shiftTemplate && [
              <div key="starttime">
                <SimpleTimeEditor
                  label={strings.Start_Time}
                  simpleTime={this.state.startTime}
                  handleChange={(startTime) => this.setState({ startTime }, () => this.checkValidate())}
                />
              </div>,
              <div style={{ marginLeft: 25 }} key="endtime">
                <SimpleTimeEditor
                  label={strings.End_Time}
                  simpleTime={this.state.endTime}
                  handleChange={(endTime) => this.setState({ endTime }, () => this.checkValidate())}
                />
              </div>
            ]}
          </div>
          <div style={{ height: 10, color: "red" }}>{this.state.errorOverlap}</div>
        </div>
      </Dialog>
    )
  }
}